import { PARENT_MESSAGE_TYPE, sendMessageToParent } from "../api/parentWindow";

export const redirectOnSuccess = async (url: string) => {
  sendMessageToParent({ type: PARENT_MESSAGE_TYPE.BEFORE_SUCCESS_REDIRECT });
  await new Promise((r) => setTimeout(r, 100));
  window.location.href = url;
};
